import { Helmet } from "react-helmet";
import CustomiseWrapper from "./style";
import Customise from "@/components/header/components/customise";
import { useTranslation } from "@/i18n/client";
import { useEffect, useState } from "react";

const CustomisePage = () => {
  const { t } = useTranslation();
  const [type, setType] = useState<number>(1); // 默认为设置语言货币页面

  useEffect(() => {
    // 在客户端获取URL参数
    const urlParams = new URLSearchParams(window.location.search);
    const typeParam = urlParams.get("type");
    
    // 如果URL中有type参数，则将其转换为数字
    if (typeParam) {
      const typeNumber = parseInt(typeParam, 10);
      // 确保type值有效（0、1或2）
      if (!isNaN(typeNumber) && (typeNumber === 0 || typeNumber === 1 || typeNumber === 2)) {
        setType(typeNumber);
      }
    }
  }, []);
  return (
    <CustomiseWrapper>
      <div>
        <Helmet>
          <title>{`${t("seo.title.customise")} | Joybuy`}</title>
          <meta name="description" content={t("seo.description.allDesc")} />
        </Helmet>
        <Customise type={type} />
      </div>
    </CustomiseWrapper>
  );
};

export default CustomisePage;
